



import React, { useState } from "react";
// import CateringItems from "./CateringItems";
// import Catreningitem from "../Catreningitem";
import Cateringuserbanners from "./Cateringuserbanners";
import AllCaters from "./AllCaters";
import CustomizeMenu from "./CustomizeMenu";
import { useLocation, useNavigate, Link } from "react-router-dom";

const UserCateringLandingPage = () => {
    const [activeView, setActiveView] = useState("packages"); // "packages" or "customize"
    const isMobile = window.innerWidth <= 768;
    // Mock data for demonstration - replace with actual data from your API
    const mockCategories = [
        { id: 1, name: "Breakfast", packageType: "Breakfast" },
        { id: 2, name: "Lunch", packageType: "Lunch" },
        { id: 3, name: "Dinner", packageType: "Dinner" },
        { id: 4, name: "Special Events", packageType: "Special Events" }
    ];

    const mockPackages = [
        {
            id: 1,
            packageName: "Classic Breakfast Package",
            packageType: "Breakfast",
            totalPrice: 299,
            description: "Start your day with our delicious breakfast spread including fresh juices, pastries, and traditional favorites.",
            tag: "Veg",
            items: [
                { itemName: "Fresh Orange Juice" },
                { itemName: "Assorted Pastries" },
                { itemName: "Vegetable Sandwich" },
                { itemName: "Fresh Fruits" }
            ],
            image: null
        },
        {
            id: 2,
            packageName: "Royal Lunch Feast",
            packageType: "Lunch",
            totalPrice: 599,
            description: "A complete lunch experience with multiple courses including starters, main course, and dessert.",
            tag: "Non_Veg",
            items: [
                { itemName: "Chicken Tikka" },
                { itemName: "Butter Chicken" },
                { itemName: "Naan Bread" },
                { itemName: "Gulab Jamun" }
            ],
            image: null
        },
        {
            id: 3,
            packageName: "Gourmet Dinner",
            packageType: "Dinner",
            totalPrice: 899,
            description: "An elegant dinner package perfect for special occasions with premium dishes and fine dining experience.",
            tag: "Non_Veg",
            items: [
                { itemName: "Paneer Tikka" },
                { itemName: "Dal Makhani" },
                { itemName: "Garlic Naan" },
                { itemName: "Rice Pudding" }
            ],
            image: null
        },
        {
            id: 4,
            packageName: "Party Special",
            packageType: "Special Events",
            totalPrice: 1499,
            description: "Everything you need for a perfect party including snacks, main course, beverages, and desserts.",
            tag: "Veg",
            items: [
                { itemName: "Spring Rolls" },
                { itemName: "Paneer Butter Masala" },
                { itemName: "Veg Biryani" },
                { itemName: "Ice Cream" }
            ],
            image: null
        }
    ];

    // Styles
    const styles = {
        container: {
            marginTop: "50px",
            padding: "0px"
        },
        header: {
            textAlign: "center",
            padding: "20px 0px 5px 0px",
            marginTop: "109px"
        },
        title: {
            fontSize: "2.5rem",
            color: "#ee6521",
            marginBottom: "10px",
            fontWeight: "700"
        },
        subtitle: {
            fontSize: "1.1rem",
            color: "#666",
            marginBottom: "30px"
        },
        buttonContainer: {
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            flexWrap: "wrap"
        },
        button: {
            padding: "15px 40px",
            fontSize: "1.1rem",
            fontWeight: "600",
            border: "none",
            borderRadius: "10px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            minWidth: "150px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
        },
        activeButton: {
            background: "#ee6521",
            color: "white",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 16px rgba(177, 93, 198, 0.3)"
        },
        inactiveButton: {
            background: "white",
            color: "#ee6521",
            border: "2px solid #ee6521"
        },
        contentArea: {
            background: "#fff",
            borderRadius: "20px",
            padding: "0px",
            maxHeight: "70vh",
            height: "auto",
            overflow: "auto",
            // boxShadow: "0 4px 20px rgba(0,0,0,0.05)"
        },
        welcomeMessage: {
            textAlign: "center",
            padding: "80px 20px",
            color: "#999",
            fontSize: "1.2rem"
        }
    };

    return (
        <div style={styles.container}>
            <p
                className="breadcrumb maamaas-home-bredcum"
                style={{
                    position: "fixed",
                    top: window.innerWidth <= 425 ? "50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "60px" : "64px",
                    left: "2vw",
                    width: "100%",
                    backgroundColor: "#fff",
                    zIndex: 100,
                    padding: "14px 0",
                    fontSize: isMobile ? "16px" : "18px",
                    fontWeight: isMobile ? "normal" : "bold",
                    textAlign: "center",
                    margin: 0,
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    flexWrap: "wrap",
                }}
            >
                <Link
                    to="/fooddashboard"
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Food & Beverages
                </Link>
                <span className="separator" style={{ margin: "0 5px" }}> &gt; </span>

                <Link
                    // to="/fooddashboard"
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Caterings
                </Link>


            </p>
            {/* Header Section */}
            <div style={styles.header}>


                {/* Button Section */}
                <div style={styles.buttonContainer}>
                    <button
                        style={{
                            ...styles.button,
                            ...(activeView === "packages"
                                ? styles.activeButton
                                : styles.inactiveButton)
                        }}
                        onClick={() => setActiveView("packages")}
                    >
                        Packages
                    </button>

                    <button
                        style={{
                            ...styles.button,
                            ...(activeView === "customize"
                                ? styles.activeButton
                                : styles.inactiveButton)
                        }}
                        onClick={() => setActiveView("customize")}
                    >
                        Customize Menu
                    </button>

                </div>

            </div>

            {/* Content Section */}
            <div style={styles.contentArea}>
                {activeView === "packages" && (
                    <Cateringuserbanners
                        setShowLogin={(show) => {
                            console.log("Show login:", show);
                        }}
                        parentId={null}
                        categories={mockCategories}
                        cateringPackages={mockPackages}
                        activeCategory="Allitems"
                    />
                )}

                {activeView === "customize" && (
                    <CustomizeMenu />
                )}

             
            </div>

        </div>
    );
};

export default UserCateringLandingPage;
